export const environment = {
  production: true,
  admin_api: 'https://app.dinami.ec:8010/api',
  factelec_api: 'https://facturacion.dinami.ec:8888/api',
  uploadfile_api: 'https://app.dinami.ec:3300/api'
};



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/environments/environment.prod.ts